import { render, staticRenderFns } from "./NoFooter.vue?vue&type=template&id=343704b6&scoped=true"
import script from "./NoFooter.vue?vue&type=script&lang=js"
export * from "./NoFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343704b6",
  null
  
)

export default component.exports